import React from 'react';
//import { PublicClientApplication } from '@azure/msal-browser';
import { UserAgentApplication } from 'msal';
import { config } from '../auth_config';
export default function withAuthProvider(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                error: null,
                isLoading: true,
                isAuthenticated: false,
                user: {}
            };
        }


        async authRedirectCallBack(error, response) {
            if (error) {
                if (error.errorMessage.indexOf('AADB2C90118') > -1) {
                    try {
                      // Password reset policy/authority
                      this.publicClientApplication.loginRedirect(config.policies.authorities.forgotPassword);
                    } catch(err) {
                      this.setState({
                        isLoading: false
                      });
                    }
                  }

            } else {

                if ((response.tokenType === 'access_token' || response.tokenType === 'id_token') && response.idToken.claims.isForgotPassword) { 
                    this.logout();
                }

                if ((response.tokenType === 'access_token' || response.tokenType === 'id_token') && (response.idToken.claims['tfp'] === config.policies.names.signUpSignIn || response.idToken.claims['tfp'] === config.policies.names.impersonation)) {
                    //Try get accessToken because of Safari 
                    //https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/Known-issue-on-Safari
                    if (this.publicClientApplication.getAccount()) {
                        setTimeout(() => {
                            this.setState({
                                isAuthenticated: true,
                                isLoading: false,
                                user: this.publicClientApplication.getAccount()
                            });
                        }, 200);   
                    }
                } 
            }
        }

        async componentDidMount() {
            this.publicClientApplication = new UserAgentApplication({
                navigateToLoginRequestUrl: false,
                auth: {
                    clientId: config.appId,
                    redirectUri: config.redirectUri,
                    navigateToLoginRequestUrl:false,
                    authority: config.policies.authorities.signUpSignIn.authority, //this.props.location.pathname === '/impersonate' ? config.policies.authorities.impersonation.authority : 
                               //                                                  config.policies.authorities.signUpSignIn.authority,
                    validateAuthority: false
                },
                cache: {
                    cacheLocation: 'localStorage',//'sessionStorage',
                    storeAuthStateInCookie: false
                }
            });
            
            this.publicClientApplication.handleRedirectCallback((error, response) => {
                
                this.setState({
                    isLoading: true
                });
                
                this.authRedirectCallBack(error, response);
                
            }); 


            //Try get access token first, workaround for safari
            //const tokern = await this.getAccessToken();

            
            if (!this.publicClientApplication.redirectResponse && this.publicClientApplication.getAccount()) {
                this.setState({
                    isAuthenticated: true,
                    isLoading: false,
                    user: this.publicClientApplication.getAccount()
                });
            }

            if (!this.publicClientApplication.redirectResponse && !this.publicClientApplication.getAccount()) {
                await this.login();
            }
    
            
        }
        render() {
            return React.createElement(WrappedComponent, Object.assign({ error: this.state.error, isAuthenticated: this.state.isAuthenticated, isLoading: this.state.isLoading, user: this.state.user, login: () => this.login(), logout: () => this.logout(), getAccessToken: (scopes) => this.getAccessToken(scopes), setError: (message, debug) => this.setErrorMessage(message, debug) }, this.props));
        }

        async login() {
            try {
                this.setState({
                    isLoading: true
                });
                
                await this.publicClientApplication.loginRedirect({
                    scopes: [`${config.scopeDNS}/api/RsReport.Read`,
                             `${config.scopeDNS}/api/Reporting.Write`,
                             `${config.scopeDNS}/api/Reporting.Read`,
                             `${config.scopeDNS}/api/Units.Read`
                            ]
                });
            }
            catch (err) {
                this.setState({
                    isAuthenticated: false,
                    user: {},
                    error: this.normalizeError(err)
                });
            }
        }

        logout() {
            this.publicClientApplication.logout();
        }

        async getAccessTokenRedirect() {
            try {
                const account = this.publicClientApplication.getAccount(); 
                if (!account) {
                    await this.login();
                }

                this.publicClientApplication.acquireTokenRedirect({
                    scopes: [`${config.scopeDNS}/api/RsReport.Read`,
                             `${config.scopeDNS}/api/Reporting.Write`,
                             `${config.scopeDNS}/api/Reporting.Read`,
                             `${config.scopeDNS}/api/Units.Read`]
                });
            } catch (err) {
                this.setState({
                    error: this.normalizeError(err)
                });
            }
            
        }

        async getAccessToken() {
            try {                
                const account = this.publicClientApplication.getAccount(); 
                if (!account) {
                    await this.login();
                }

                // Get the access token silently
                // If the cache contains a non-expired token, this function
                // will just return the cached token. Otherwise, it will
                // make a request to the Azure OAuth endpoint to get a token
                const silentResult = await this.publicClientApplication
                    .acquireTokenSilent({
                        scopes: [`${config.scopeDNS}/api/RsReport.Read`,
                                 `${config.scopeDNS}/api/Reporting.Write`,
                                 `${config.scopeDNS}/api/Reporting.Read`,
                                 `${config.scopeDNS}/api/Units.Read`
                                ]
                    });
                
                return silentResult.accessToken;
            }
            catch (err) {
                this.setState({
                    error: this.normalizeError(err)
                });
                //await this.login();
                /*await this.publicClientApplication.acquireTokenRedirect({
                    scopes: ['https://delfiauthqa.onmicrosoft.com/api/Units.Read']
                });*/
                /*if (err.errorMessage.indexOf('User login is required') > -1 || err.errorMessage.indexOf('Token renewal operation failed due to timeout') > -1) {
                    //this.login();
                    this.publicClientApplication.acquireTokenRedirect({
                        scopes: ['https://delfiauthqa.onmicrosoft.com/api/Admin.DelfiOnline',
                                'https://delfiauthqa.onmicrosoft.com/api/Admin.Statistics',
                                'https://delfiauthqa.onmicrosoft.com/api/RsReport.Read',
                                'https://delfiauthqa.onmicrosoft.com/api/Reporting.Write',
                                'https://delfiauthqa.onmicrosoft.com/api/Reporting.Read',
                                'https://delfiauthqa.onmicrosoft.com/api/Units.Read']
                    });

                    return null;
                }*/

                if (err.errorMessage) {
                   
                    this.publicClientApplication.acquireTokenRedirect({
                        scopes: [`${config.scopeDNS}/api/RsReport.Read`,
                                 `${config.scopeDNS}/api/Reporting.Write`,
                                 `${config.scopeDNS}/api/Reporting.Read`,
                                 `${config.scopeDNS}/api/Units.Read`]
                    });
                }

                return null;
                    /*
                    return null;
                } /*else {
                    await this.login();
                }*/
            }
        }

        // </getUserProfileSnippet>
        setErrorMessage(message, debug) {
            this.setState({
                error: { message: message, debug: debug }
            });
        }

        normalizeError(error) {
            var normalizedError = {};
            if (typeof (error) === 'string') {
                var errParts = error.split('|');
                normalizedError = errParts.length > 1 ?
                    { message: errParts[1], debug: errParts[0] } :
                    { message: error };
            }
            else {
                normalizedError = {
                    message: error.message,
                    debug: JSON.stringify(error)
                };
            }
            return normalizedError;
        }

        isInteractionRequired(error) {
            if (!error.message || error.message.length <= 0) {
                return false;
            }
            return (error.message.indexOf('consent_required') > -1 ||
                error.message.indexOf('interaction_required') > -1 ||
                error.message.indexOf('login_required') > -1 ||
                error.message.indexOf('no_account_in_silent_request') > -1);
        }
    };
}